import React, { useMemo, useState } from 'react';
import DataTable from 'react-data-table-component';

import '../../../css/components/Home/OrderPreview/OrderPreview.css';

import { formatTaiwanDate, OrderId } from '../../../utils';
import { GenericModal } from '../../../components';
import { OrderInfoCardList } from '../../../constants';

const OrderPreview = ({ data }) => {
    const [selectedEvent, setSelectedEvent] = useState(null); // 存放點擊事件
    const [isModalOpen, setIsModalOpen] = useState(false);

    const ordersData = useMemo(() => data.filter(item => item.status === 0), [data]);

    const columns = useMemo(() => [
        { name: '單號', selector: row => OrderId(row.id), sortable: true },
        { name: '姓名', selector: row => row.name, sortable: true },
        // { name: '電話', selector: row => row.phone },
        { name: '送貨日期', selector: row => formatTaiwanDate(row.deliveryDate), sortable: true },
        { name: '寄送狀態', cell: row => <span className={`badge ${row.isShipped ? "bg-success" : "bg-warning text-dark"}`}>{row.isShipped ? "已送達" : "未送達"}</span>, key: "status" },
        {
            name: "操作",
            cell: row => (
                <button
                    className="btn btn-primary btn-sm"
                    onClick={() => {
                        setSelectedEvent({
                            ...row,
                            title: row.name + ` -  ${row.isShipped ? "已送達" : "未送達"}`,
                            publicId: OrderId(row.id),
                            address: `${row.addressCity}${row.addressDistrict}${row.addressDetailed}`,
                            deliveryDate: row.deliveryDate.slice(0, 10)
                        });
                        setIsModalOpen(true);
                    }}
                >
                    詳情
                </button>
            ),
            key: "action"
        }
    ], []);

    const [filterText, setFilterText] = useState('');
    const filteredItems = useMemo(() =>
        ordersData.filter(item =>
            OrderId(item.id).includes(filterText) ||
            item.name.includes(filterText) ||
            item.phone.includes(filterText) ||
            item.deliveryDate.includes(filterText)
        ),
        [ordersData, filterText]
    );

    return (
        <>

            {selectedEvent && (
                <GenericModal
                    isOpen={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    children={
                        <div className="card order-info-card">
                            {
                                OrderInfoCardList.map(item => {
                                    if (item.field === 'isShipped') {

                                        return <div className="mb-2">
                                            <strong>{item.name}</strong>
                                            <span className={`status ${selectedEvent[item.field] ? 'shipped' : 'pending'}`}>
                                                {selectedEvent[item.field] ? "已送達" : "未送達"}
                                            </span>
                                        </div>
                                    } else if (item.field === 'status') {
                                        return <div className="mb-2">
                                            <strong>{item.name}</strong>
                                            <span className={`status ${selectedEvent[item.field] ? selectedEvent[item.field] === 1 ? 'approved' : 'unReviewed' : 'rejected'}`}>
                                                {selectedEvent[item.field] === 1 ? "已通過" : selectedEvent[item.field] === 2 ? "未通過" : "未審核"}
                                            </span>
                                        </div>
                                    } else if (item.field === 'title') {
                                        return <h5>{selectedEvent[item.field]}</h5>
                                    } else {
                                        return <div className="mb-2"><strong>{item.name}</strong> <span>{selectedEvent[item.field]}</span></div>
                                    }
                                })
                            }
                        </div>
                    }
                />

            )}
            <div className="card-header">
                <i className="fas fa-table me-1"></i>
                未審核訂單預覽
            </div>
            <div className="card-body">
                <input
                    type="text"
                    placeholder="搜尋..."
                    className="form-control mb-3"
                    value={filterText}
                    onChange={e => setFilterText(e.target.value)}
                    style={{ maxWidth: '300px' }}
                />
                <DataTable
                    columns={columns}
                    data={filteredItems}
                    pagination
                    paginationPerPage={5}
                    paginationRowsPerPageOptions={[5]}
                    highlightOnHover
                    striped
                    noDataComponent="無此訂單資訊"
                    paginationComponentOptions={{
                        rowsPerPageText: '每頁筆數',
                        rangeSeparatorText: '總共',
                        // selectAllRowsItem: true,
                        // selectAllRowsItemText: '全部'
                    }}
                />
            </div>
        </>
    );
};

export { OrderPreview };
